import { useContext } from "react";
import { LogoutContext } from "../shared/logout-provider/LogoutProvider";

const useLogout = () => {
  const logoutContext = useContext(LogoutContext);
  return logoutContext.logout;
};
export default useLogout;
